import React from 'react';
import NavBar from '../../components/userHomeNavBar/navBar';
import SideBar from '../../components/userHomeSideBar/sideBar';
import './org.css';

const OrgDashboardPage = () => {
    const exampleServices = [
        { name: 'Service 1' },
        { name: 'Service 2' },
        { name: 'Service 3' },
        { name: 'Service 4' },
        { name: 'Service 5' },
    ];

    const exampleBookings = [
        { userName: 'User 1', serviceName: 'Service 1', dateTime: '25/12/2023 03:45 PM' },
        { userName: 'User 2', serviceName: 'Service 2', dateTime: '26/12/2023 11:30 AM' },
        { userName: 'User 3', serviceName: 'Service 3', dateTime: '27/12/2023 09:00 AM' },
        { userName: 'User 4', serviceName: 'Service 1', dateTime: '28/12/2023 01:00 PM' },
        { userName: 'User 5', serviceName: 'Service 2', dateTime: '29/12/2023 10:15 AM' },
        { userName: 'User 6', serviceName: 'Service 3', dateTime: '30/12/2023 02:45 PM' },
        { userName: 'User 7', serviceName: 'Service 1', dateTime: '31/12/2023 04:30 PM' },
        { userName: 'User 8', serviceName: 'Service 2', dateTime: '01/01/2024 12:00 PM' },
        { userName: 'User 9', serviceName: 'Service 3', dateTime: '02/01/2024 11:45 AM' },
        { userName: 'User 10', serviceName: 'Service 1', dateTime: '03/01/2024 01:15 PM' },
    ];

    return (
        <div className="theme-blush">
            <div className="overlay"></div>
            <NavBar />
            <SideBar />


            
<section className="content profile-page">
  <div className="block-header">
    <div className="row">
      <div className="col-lg-7 col-md-6 col-sm-12">
        <h2>Agent Profile
          <small className="text-muted">Welcome to Compass</small>
        </h2>
      </div>
      <div className="col-lg-5 col-md-6 col-sm-12">                
        <button className="btn btn-primary btn-icon btn-round hidden-sm-down float-right m-l-10" type="button">
          <i className="zmdi zmdi-plus" />
        </button>
        <ul className="breadcrumb float-md-right">
          <li className="breadcrumb-item"><a href="index.html"><i className="zmdi zmdi-home" /> Compass</a></li>
          <li className="breadcrumb-item"><a href="javascript:void(0);">Agent</a></li>
          <li className="breadcrumb-item active">Agent Profile</li>
        </ul>                
      </div>
    </div>
  </div>    
  <div className="container-fluid">       
    <div className="row clearfix">
      <div className="col-lg-4 col-md-12">
        <div className="card member-card">
          <div className="header l-cyan">
            <h4 className="m-t-10">Michael Dorsey</h4>
          </div>
          <div className="member-img">
            <a href="profile.html" className>
              <img src="/assets/img/profile_av.jpg" className="rounded-circle" alt="profile-image" />
            </a>
          </div>
          <div className="body">
            <div className="col-12">
              <ul className="social-links list-unstyled">
                <li><a title="facebook" href="#"><i className="zmdi zmdi-facebook" /></a></li>
                <li><a title="twitter" href="#"><i className="zmdi zmdi-twitter" /></a></li>
                <li><a title="instagram" href="#"><i className="zmdi zmdi-instagram" /></a></li>
              </ul>
              <p className="text-muted">795 Folsom Ave, Suite 600 San Francisco, CADGE 94107</p>
            </div>
            <hr />
            <div className="row">
              <div className="col-4">
                <h5>852</h5>
                <small>Following</small>
              </div>
              <div className="col-4">
                <h5>13k</h5>
                <small>Followers</small>
              </div>
              <div className="col-4">
                <h5>234</h5>
                <small>Post</small>
              </div>                            
            </div>
          </div>
        </div>
        <div className="card">
          <ul className="nav nav-tabs">
            <li className="nav-item"><a className="nav-link active" data-toggle="tab" href="#about">About</a></li>
            <li className="nav-item"><a className="nav-link" data-toggle="tab" href="#friends">Friends</a></li>                        
          </ul>
          <div className="tab-content">
            <div className="tab-pane body active" id="about">
              <small className="text-muted">Position: </small>
              <p>Agent</p>
              <hr />
              <small className="text-muted">Estate: </small>
              <p>Cleveland</p>
              <hr />
              <small className="text-muted">Email address: </small>
              <p>michael@gmail.com</p>
              <hr />
              <small className="text-muted">Phone: </small>
              <p>+ 202-555-0191</p>                            
              <hr />
              <ul className="list-unstyled">
                <li>
                  <div>Marketing</div>
                  <div className="progress m-b-20">
                    <div className="progress-bar l-blue " role="progressbar" aria-valuenow={89} aria-valuemin={0} aria-valuemax={100} style={{width: '89%'}}> <span className="sr-only">62% Complete</span> </div>
                  </div>
                </li>
                <li>
                  <div>Maths</div>
                  <div className="progress m-b-20">
                    <div className="progress-bar l-green " role="progressbar" aria-valuenow={56} aria-valuemin={0} aria-valuemax={100} style={{width: '56%'}}> <span className="sr-only">87% Complete</span> </div>
                  </div>
                </li>
                <li>
                  <div>Communication</div>
                  <div className="progress m-b-20">
                    <div className="progress-bar l-amber" role="progressbar" aria-valuenow={78} aria-valuemin={0} aria-valuemax={100} style={{width: '78%'}}> <span className="sr-only">32% Complete</span> </div>
                  </div>
                </li>
                <li>
                  <div>English</div>
                  <div className="progress m-b-20">
                    <div className="progress-bar l-blush" role="progressbar" aria-valuenow={43} aria-valuemin={0} aria-valuemax={100} style={{width: '43%'}}> <span className="sr-only">56% Complete</span> </div>
                  </div>
                </li>
              </ul>
            </div>
            <div className="tab-pane body" id="friends">
              <ul className="new_friend_list list-unstyled row">
                <li className="col-lg-4 col-md-2 col-sm-6 col-4">
                  <a href>
                    <img src="/assets/img/sm/avatar1.jpg" className="img-thumbnail" alt="User Image" />
                    <h6 className="users_name">Jackson</h6>
                    <small className="join_date">Today</small>
                  </a>
                </li>
                <li className="col-lg-4 col-md-2 col-sm-6 col-4">
                  <a href>
                    <img src="/assets/img/sm/avatar2.jpg" className="img-thumbnail" alt="User Image" />
                    <h6 className="users_name">Aubrey</h6>
                    <small className="join_date">Yesterday</small>
                  </a>
                </li>
                <li className="col-lg-4 col-md-2 col-sm-6 col-4">
                  <a href>
                    <img src="/assets/img/sm/avatar3.jpg" className="img-thumbnail" alt="User Image" />
                    <h6 className="users_name">Oliver</h6>
                    <small className="join_date">08 Nov</small>
                  </a>
                </li>
                <li className="col-lg-4 col-md-2 col-sm-6 col-4">
                  <a href>
                    <img src="/assets/img/sm/avatar4.jpg" className="img-thumbnail" alt="User Image" />
                    <h6 className="users_name">Isabella</h6>
                    <small className="join_date">12 Dec</small>
                  </a>
                </li>
                <li className="col-lg-4 col-md-2 col-sm-6 col-4">
                  <a href>
                    <img src="/assets/img/sm/avatar1.jpg" className="img-thumbnail" alt="User Image" />
                    <h6 className="users_name">Jacob</h6>
                    <small className="join_date">12 Dec</small>
                  </a>
                </li>
                <li className="col-lg-4 col-md-2 col-sm-6 col-4">
                  <a href>
                    <img src="/assets/img/sm/avatar5.jpg" className="img-thumbnail" alt="User Image" />
                    <h6 className="users_name">Matthew</h6>
                    <small className="join_date">17 Dec</small>
                  </a>
                </li>                            
              </ul>
            </div>                        
          </div>
        </div>
      </div>
      <div className="col-lg-8 col-md-12">
        <div className="card">
          <ul className="nav nav-tabs">
            <li className="nav-item"><a className="nav-link active" data-toggle="tab" href="#mypost">My Post</a></li>
            <li className="nav-item"><a className="nav-link" data-toggle="tab" href="#timeline">Timeline</a></li>
            <li className="nav-item"><a className="nav-link" data-toggle="tab" href="#usersettings">Setting</a></li>
          </ul>
        </div>
        <div className="tab-content">
          <div role="tabpanel" className="tab-pane blog-page active" id="mypost">
            <div className="card single_post">
              <div className="body">
                <h3 className="m-t-0 m-b-5"><a href="blog-details.html">All photographs are accurate. None of them is the truth</a></h3>
                <ul className="meta">
                  <li><a href="#"><i className="zmdi zmdi-account col-blue" />Posted By: John Smith</a></li>
                  <li><a href="#"><i className="zmdi zmdi-label col-red" />Photography</a></li>
                  <li><a href="#"><i className="zmdi zmdi-comment-text col-blue" />Comments: 3</a></li>
                </ul>
              </div>                    
              <div className="body">
                <div className="img-post m-b-15">
                  <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
                    <div className="carousel-inner" role="listbox">
                      <div className="carousel-item active">
                        <img className="d-block img-fluid" src="/assets/img/blog/blog-page-1.jpg" alt="First slide" />
                      </div>
                      <div className="carousel-item">
                        <img className="d-block img-fluid" src="/assets/img/blog/blog-page-2.jpg" alt="Second slide" />
                      </div>
                      <div className="carousel-item">
                        <img className="d-block img-fluid" src="/assets/img/blog/blog-page-3.jpg" alt="Third slide" />
                      </div>
                    </div>
                    <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                      <span className="carousel-control-prev-icon" aria-hidden="true" />
                      <span className="sr-only">Previous</span>
                    </a>
                    <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                      <span className="carousel-control-next-icon" aria-hidden="true" />
                      <span className="sr-only">Next</span>
                    </a>
                  </div>
                  <div className="social_share">                            
                    <button className="btn btn-primary btn-icon btn-icon-mini btn-round"><i className="zmdi zmdi-facebook" /></button>
                    <button className="btn btn-primary btn-icon btn-icon-mini btn-round"><i className="zmdi zmdi-twitter" /></button>
                    <button className="btn btn-primary btn-icon btn-icon-mini btn-round"><i className="zmdi zmdi-instagram" /></button>
                  </div>
                </div>
                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal</p>
                <a href="blog-details.html" title="read more" className="btn btn-round btn-info">Read More</a>                        
              </div>
            </div>
            <div className="card single_post">
              <div className="body">
                <h3 className="m-t-0 m-b-5"><a href="blog-details.html">Apple Introduces Search Ads Basic</a></h3>
                <ul className="meta">
                  <li><a href="#"><i className="zmdi zmdi-account col-blue" />Posted By: John Smith</a></li>
                  <li><a href="#"><i className="zmdi zmdi-label col-amber" />Technology</a></li>
                  <li><a href="#"><i className="zmdi zmdi-comment-text col-blue" />Comments: 3</a></li>
                </ul>
              </div>                    
              <div className="body">
                <div className="img-post m-b-15">
                  <img src="/assets/img/blog/blog-page-2.jpg" alt="Awesome Image" />
                  <div className="social_share">                            
                    <button className="btn btn-primary btn-icon btn-icon-mini btn-round"><i className="zmdi zmdi-facebook" /></button>
                    <button className="btn btn-primary btn-icon btn-icon-mini btn-round"><i className="zmdi zmdi-twitter" /></button>
                    <button className="btn btn-primary btn-icon btn-icon-mini btn-round"><i className="zmdi zmdi-instagram" /></button>
                  </div>
                </div>
                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal</p>
                <a href="blog-details.html" title="read more" className="btn btn-round btn-info">Read More</a>                        
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-lg-6 col-md-12">
                <div className="card single_post">
                  <div className="body">
                    <h3 className="m-t-0 m-b-5"><a href="blog-details.html">WTCR from 2018: new rules, more cars, more races</a></h3>
                    <ul className="meta">
                      <li><a href="#"><i className="zmdi zmdi-account col-blue" />Posted By: John Smith</a></li>
                      <li><a href="#"><i className="zmdi zmdi-label col-lime" />Sports</a></li>
                      <li><a href="#"><i className="zmdi zmdi-comment-text col-blue" />Comments: 3</a></li>
                    </ul>
                  </div>                    
                  <div className="body">
                    <div className="img-post m-b-15">
                      <img src="/assets/img/blog/blog-page-3.jpg" alt="Awesome Image" />
                      <div className="social_share">                            
                        <button className="btn btn-primary btn-icon btn-icon-mini btn-round"><i className="zmdi zmdi-facebook" /></button>
                        <button className="btn btn-primary btn-icon btn-icon-mini btn-round"><i className="zmdi zmdi-twitter" /></button>
                        <button className="btn btn-primary btn-icon btn-icon-mini btn-round"><i className="zmdi zmdi-instagram" /></button>
                      </div>
                    </div>
                    <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old</p>
                    <a href="blog-details.html" title="read more" className="btn btn-round btn-info">Read More</a>                        
                  </div>
                </div>
              </div> 
              <div className="col-lg-6 col-md-12">
                <div className="card single_post">
                  <div className="body">
                    <h3 className="m-t-0 m-b-5"><a href="blog-details.html">CSS Timeline Examples from CodePen</a></h3>
                    <ul className="meta">
                      <li><a href="#"><i className="zmdi zmdi-account col-blue" />Posted By: John Smith</a></li>
                      <li><a href="#"><i className="zmdi zmdi-label col-green" />Web Design</a></li>
                      <li><a href="#"><i className="zmdi zmdi-comment-text col-blue" />Comments: 3</a></li>
                    </ul>
                  </div>                    
                  <div className="body">
                    <div className="img-post m-b-15">
                      <img src="/assets/img/blog/blog-page-4.jpg" alt="Awesome Image" />
                      <div className="social_share">                            
                        <button className="btn btn-primary btn-icon btn-icon-mini btn-round"><i className="zmdi zmdi-facebook" /></button>
                        <button className="btn btn-primary btn-icon btn-icon-mini btn-round"><i className="zmdi zmdi-twitter" /></button>
                        <button className="btn btn-primary btn-icon btn-icon-mini btn-round"><i className="zmdi zmdi-instagram" /></button>
                      </div>
                    </div>
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words</p>
                    <a href="blog-details.html" title="read more" className="btn btn-round btn-info">Read More</a>                        
                  </div>
                </div>
              </div>
            </div>
            <ul className="pagination pagination-primary">
              <li className="page-item"><a className="page-link" href="#">Previous</a></li>
              <li className="page-item active"><a className="page-link" href="#">1</a></li>
              <li className="page-item"><a className="page-link" href="#">2</a></li>
              <li className="page-item"><a className="page-link" href="#">3</a></li>
              <li className="page-item"><a className="page-link" href="#">Next</a></li>
            </ul>                
          </div>
          <div role="tabpanel" className="tab-pane" id="timeline">
            <ul className="cbp_tmtimeline">
              <li>
                <time className="cbp_tmtime" dateTime="2017-11-04T18:30"><span className="hidden">25/12/2017</span> <span className="large">Now</span></time>
                <div className="cbp_tmicon"><i className="zmdi zmdi-account" /></div>
                <div className="cbp_tmlabel empty"> <span>No Activity</span> </div>
              </li>
              <li>
                <time className="cbp_tmtime" dateTime="2017-11-04T03:45"><span>03:45 AM</span> <span>Today</span></time>
                <div className="cbp_tmicon bg-info"><i className="zmdi zmdi-label" /></div>
                <div className="cbp_tmlabel">
                  <h2><a href="javascript:void(0);">Art Ramadani</a> <span>posted a status update</span></h2>
                  <p>Tolerably earnestly middleton extremely distrusts she boy now not. Add and offered prepare how cordial two promise. Greatly who affixed suppose but enquire compact prepare all put. Added forth chief trees but rooms think may.</p>
                </div>
              </li>
              <li>
                <time className="cbp_tmtime" dateTime="2017-11-03T13:22"><span>01:22 PM</span> <span>Yesterday</span></time>
                <div className="cbp_tmicon bg-green"> <i className="zmdi zmdi-case" /></div>
                <div className="cbp_tmlabel">
                  <h2><a href="javascript:void(0);">Job Meeting</a></h2>
                  <p>You have a meeting at <strong>Laborator Office</strong> Today.</p>
                </div>
              </li>
              <li>
                <time className="cbp_tmtime" dateTime="2017-10-22T12:13"><span>12:13 PM</span> <span>Two weeks ago</span></time>
                <div className="cbp_tmicon bg-blush"><i className="zmdi zmdi-pin" /></div>
                <div className="cbp_tmlabel">
                  <h2><a href="javascript:void(0);">Arlind Nushi</a> <span>checked in at</span> <a href="javascript:void(0);">New York</a></h2>
                  <blockquote>
                    <p className="blockquote blockquote-primary">
                      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout."                                    
                      <br />
                      <small>
                        - Isabella
                      </small>
                    </p>
                  </blockquote>
                  <div className="row clearfix">
                    <div className="col-lg-12">
                      <div className="map m-t-10">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d193595.91477011208!2d-74.11976308802028!3d40.69740344230033!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew+York%2C+NY%2C+USA!5e0!3m2!1sen!2sin!4v1508039335245" frameBorder={0} style={{border: 0, width: '100%'}} allowFullScreen />
                      </div>
                    </div>
                  </div>							
                </div>
              </li>
              <li>
                <time className="cbp_tmtime" dateTime="2017-10-22T12:13"><span>12:13 PM</span> <span>Two weeks ago</span></time>
                <div className="cbp_tmicon bg-orange"><i className="zmdi zmdi-camera" /></div>
                <div className="cbp_tmlabel">
                  <h2><a href="javascript:void(0);">Eroll Maxhuni</a> <span>uploaded</span> 4 <span>new photos to album</span> <a href="javascript:void(0);">Summer Trip</a></h2>
                  <blockquote>Pianoforte principles our unaffected not for astonished travelling are particular.</blockquote>
                  <div className="row">
                    <div className="col-lg-3 col-md-6 col-6"><a href="javascript:void(0);"><img src="/assets/img/image1.jpg" alt className="img-fluid img-thumbnail m-t-30" /></a> </div>
                    <div className="col-lg-3 col-md-6 col-6"><a href="javascript:void(0);"> <img src="/assets/img/image2.jpg" alt className="img-fluid img-thumbnail m-t-30" /></a> </div>
                    <div className="col-lg-3 col-md-6 col-6"><a href="javascript:void(0);"> <img src="/assets/img/image3.jpg" alt className="img-fluid img-thumbnail m-t-30" /> </a> </div>
                    <div className="col-lg-3 col-md-6 col-6"><a href="javascript:void(0);"> <img src="/assets/img/image4.jpg" alt className="img-fluid img-thumbnail m-t-30" /> </a> </div>
                  </div>
                </div>
              </li>
              <li>
                <time className="cbp_tmtime" dateTime="2017-11-03T13:22"><span>01:22 PM</span> <span>Two weeks ago</span></time>
                <div className="cbp_tmicon bg-green"> <i className="zmdi zmdi-case" /></div>
                <div className="cbp_tmlabel">
                  <h2><a href="javascript:void(0);">Job Meeting</a></h2>
                  <p>You have a meeting at <strong>Laborator Office</strong> Today.</p>                            
                </div>
              </li>
              <li>
                <time className="cbp_tmtime" dateTime="2017-10-22T12:13"><span>12:13 PM</span> <span>Month ago</span></time>
                <div className="cbp_tmicon bg-blush"><i className="zmdi zmdi-pin" /></div>
                <div className="cbp_tmlabel">
                  <h2><a href="javascript:void(0);">Arlind Nushi</a> <span>checked in at</span> <a href="javascript:void(0);">Laborator</a></h2>
                  <blockquote>Great place, feeling like in home.</blockquote>                            
                </div>
              </li>
            </ul>
          </div>
          <div role="tabpanel" className="tab-pane" id="usersettings">
            <div className="card">
              <div className="header">
                <h2><strong>Security</strong> Settings</h2>
              </div>
              <div className="body">
                <div className="form-group">
                  <input type="text" className="form-control" placeholder="Username" />
                </div>
                <div className="form-group">
                  <input type="password" className="form-control" placeholder="Current Password" />
                </div>
                <div className="form-group">
                  <input type="password" className="form-control" placeholder="New Password" />
                </div>
                <button className="btn btn-info btn-round">Save Changes</button>                               
              </div>
            </div>
            <div className="card">
              <div className="header">
                <h2><strong>Account</strong> Settings</h2>
              </div>
              <div className="body">
                <div className="row clearfix">
                  <div className="col-lg-6 col-md-12">
                    <div className="form-group">
                      <input type="text" className="form-control" placeholder="First Name" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <div className="form-group">
                      <input type="text" className="form-control" placeholder="Last Name" />
                    </div>
                  </div>                                    
                  <div className="col-lg-4 col-md-12">
                    <div className="form-group">
                      <input type="text" className="form-control" placeholder="City" />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12">
                    <div className="form-group">
                      <input type="text" className="form-control" placeholder="E-mail" />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12">
                    <div className="form-group">
                      <input type="text" className="form-control" placeholder="Country" />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <textarea rows={4} className="form-control no-resize" placeholder="Address Line 1" defaultValue={""} />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="checkbox">
                      <input id="procheck1" type="checkbox" />
                      <label htmlFor="procheck1">Profile Visibility For Everyone</label>
                    </div>
                    <div className="checkbox">
                      <input id="procheck2" type="checkbox" />
                      <label htmlFor="procheck2">New task notifications</label>
                    </div>
                    <div className="checkbox">
                      <input id="procheck3" type="checkbox" />
                      <label htmlFor="procheck3">New friend request notifications</label>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <button className="btn btn-primary btn-round">Save Changes</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

            <section className="content">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Organization Dashboard
                                <small>Welcome to enableSEND</small>
                            </h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item"><a href="index.html"><i className="zmdi zmdi-home"></i> App</a></li>
                                <li className="breadcrumb-item"><a href="blog-dashboard.html">Organization</a></li>
                                <li className="breadcrumb-item active">Dashboard</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row clearfix">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="card">
                                <div className="header">
                                    <h2><strong>Organization</strong> Info</h2>
                                </div>
                                <div className="body">
                                    <button className="btn btn-primary btn-round m-r-10 m-b-10">Manage Details</button>
                                    <button className="btn btn-primary btn-round m-b-10">Manage Images</button>
                                </div>
                            </div>

                            <div className="card">
                                <div className="header">
                                    <h2><strong>Services</strong></h2>
                                </div>
                                <div className="body">
                                    <ul className="list-unstyled">
                                        {exampleServices.map((service, index) => (
                                            <li key={index} className="service-item d-flex justify-content-between align-items-center m-b-10">
                                                <span>{service.name}</span>
                                                <div>
                                                    <button className="btn btn-warning btn-round m-r-10">Change Availability</button>
                                                    <button className="btn btn-danger btn-round"><i className="zmdi zmdi-delete"></i></button>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                    <button className="btn btn-primary btn-round">Add Service</button>
                                </div>
                            </div>

                            <div className="card">
                                <div className="header">
                                    <h2><strong>Bookings</strong></h2>
                                </div>
                                <div className="body">
                                    <ul className="list-unstyled">
                                        {exampleBookings.map((booking, index) => (
                                            <li key={index} className="booking-item d-flex justify-content-between align-items-center m-b-10">
                                                <div>
                                                    <span>{booking.userName} - {booking.serviceName}</span>
                                                    <span className="m-l-10">{booking.dateTime}</span>
                                                </div>
                                                <div>
                                                    <button className="btn btn-success btn-round m-r-10">Accept</button>
                                                    <button className="btn btn-danger btn-round">Reject</button>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default OrgDashboardPage;